import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import { QuestionV2 } from "@/lib/model/exambuilder/question-v2";
import { Dimension } from "@/lib/dimension/dimension";
import { Param } from "../model/exam/result";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";

export class Position extends Model {
  questionPositionId = 0;
  name = "";
}
export class Industry extends Model {
  questionIndustryId = 0;
  name = "";
}
export class PositionIndustryList extends Model {
  questionPositionList: Position[] = [new Position()];
  questionIndustryList: Industry[] = [new Industry()];
}

export default class PositionList extends Model {
  //行业岗位list
  static get() {
    return request.post("/aiExam/question2/features").then(resp => {
      return new PositionIndustryList().assign(resp.data.data);
    });
  }
  //行业岗位筛选出的维度
  static getDimensionList(param: any, ignoreNoQuestion = 0) {
    param.ignoreNoQuestionDimension = ignoreNoQuestion; //忽视没有题目的维度 1 0
    return request.post("/aiExam/dimension/list", param).then(resp => {
      return resp.data.data;
    });
  }

  // questionPositionIdList:
  //   questionIndustryIdList:
  // dimensionKey:
  //   nameLike: "",
  // returnAll: true,
  //templateId
  //行业岗位筛选出的模板 入参
  static getTemplateList(param: any) {
    return request.post("/aiExam/exam2/defaultTemplates", param).then(resp => {
      return resp.data.data;
    });
  }
}
export class DimensionLevel extends Model {
  dimensionKey = "";
  level = 0;
}

export class Template extends Model {
  templateId = 0;
  name = ""; // 模版名称
  description = ""; // 模版描述
  useTime = ""; // 用时
  vipLevel = 0; // 付费类型
  questionPositionId = 0; // 岗位id
  questionIndustryId = 0; // 行业id
  questionPositionName = ""; // 岗位名称
  questionIndustryName = ""; // 行业名称
  questionList: QuestionV2[] = [new QuestionV2()]; // 题目列表
  questionCount = 0; // 题目数量
  dimensionList: Dimension[] = [new Dimension()]; // 维度列表
  dimensionLevelList: DimensionLevel[] = [new DimensionLevel()]; // 维度等级列表

  //模板model转换成面试model
  public assignIntoExamV2() {
    const examV2 = new ExamV2Custom();
    //todo: 有些字段需要转换
    // examV2.vipLevel = this.vipLevel;
    examV2.dimensionLevelList = this.dimensionLevelList;
    examV2.dimensionKeyList = this.dimensionList.map(d => {
      return d.dimensionKey;
    });
    examV2.questionIdList = this.questionList.map(q => {
      return q.questionId;
    });
    examV2.industryId = this.questionIndustryId;
    examV2.positionId = this.questionPositionId;
    return examV2;
  }
}
